(() => {
	function init() {
		const $freeScroll = $('[data-free-scroll]');

		$freeScroll.each(function () {
			new Swiper(this, {
				slidesPerView: 'auto',
				spaceBetween: parseInt(this.dataset.spacing) || 0,
				freeMode: true,
				navigation: {
					nextEl: this.dataset.next,
					prevEl: this.dataset.prev
				}
			});
		});
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		init();
	});

	$WINDOW.on('page:load-completed', (e) => {
		init();
	});
})();
